import { render } from "./ChangeLang.vue?vue&type=template&id=50afee96&scoped=true"
import script from "./ChangeLang.vue?vue&type=script&lang=js"
export * from "./ChangeLang.vue?vue&type=script&lang=js"

import "./ChangeLang.vue?vue&type=style&index=0&id=50afee96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50afee96"]])

export default __exports__